import {h, render} from 'preact';
import $ from '@modules/jquery-import';
import Provider from 'preact-context-provider';
import PrimaryNav from '@components/navigation/desktop';
import SiteMapService from '@services/SiteMapService';
import OrdersService from '@services/OrdersService';
import propEq from 'ramda/src/propEq';
import find from 'ramda/src/find';
import {getPageRoot} from '@util/URLUtils';
import {jqueryValidate, Waypoints, MenuAim} from '@modules/lazy-imports';

const $NAV_SITE = '#nav-lvl-site';
const $NAV_PRIMARY = '#nav-lvl-primary';
const $DROP_MENU = '.nav-drop-menu';
const $NAV_MENU = '.nav-menu';
const $NAV_ITEM = '.nav-item--with-indicator';
const $MENU_TRIGGER = '[data-menu-trigger]';

import {$HEADER, $BODY, $CONTENT_BODY, $CONTENT_PANE, $CONTENT_WINDOW} from '@config/selectors';

const getSelectedTaxonomy = ( pageRoot, taxonomyList ) => find( propEq( 'url', pageRoot ), taxonomyList );

class DesktopMenu {

    _menuHoverTimeoutId = null;
    _frozenMenus = [];

    constructor( $container ) {
        console.warn( '[Init Desktop Header]' );
        this.navPrimary = $container;

        this.initMenu();
    }

    async initMenu() {

        /*const [taxonomyData, pastPurchaseData] = await Promise.all( [
            SiteMapService.getTaxonomy(),
            // todo -> swap out with "recently viewed" data
            OrdersService.getPastPurchases( 3 )
        ] );*/
        const taxonomyData = await SiteMapService.getTaxonomy();

        const shopppingTaxonomyId = taxonomyData[0].sysId;
        const pageRoot = getPageRoot( window.location.pathname );
        const selectedTaxonomy = getSelectedTaxonomy( pageRoot, taxonomyData ) || taxonomyData[0];

        render(
            <Provider
                isShoppingTaxonomy={shopppingTaxonomyId === selectedTaxonomy.sysId}
                hasFormulary={upi.User.info.salesChannel === 'lgp'}
                // pastPurchases={pastPurchaseData.slice( 0, 3 )}
                // todo -> swap out with "recently viewed" data
                pastPurchases={[]}
            >
                <PrimaryNav taxonomy={selectedTaxonomy}/>
            </Provider>,
            null,
            this.navPrimary[0]
        );

        this.siteHeader = $( $HEADER );
        this.siteBody = $( $BODY );
        this.contentPane = $( $CONTENT_PANE );
        this.navSite = $( $NAV_SITE );
        this.navItems = $( $NAV_ITEM ).parent( 'li' );
        this.dropMenus = $( $DROP_MENU );
        this.submenuAds = $( `${$DROP_MENU} .submenu-figure` );
        const loginForm = $( '#loginForm1' );

        if ( loginForm[0] ) {
            jqueryValidate().then( () => loginForm.validate() );
        }

        // toggle collapsable header
        this.initCollapsingHeader( $CONTENT_BODY, $CONTENT_WINDOW );
        this.initEvents();
    }

    async initEvents() {
        await MenuAim();

        this.siteHeader
            .on( 'focusin', `${$MENU_TRIGGER} input`, this.onFocusin )
            .on( 'touchstart', $MENU_TRIGGER, this.toggleMenu )
            .on( 'click', 'a[href*="#"]', this.onInPageNavigation )
        // .on( 'mouseenter', $MENU_TRIGGER, this.onDropMenuEnter )
        // .on( 'mouseleave', $MENU_TRIGGER, this.onDropMenuLeave );

        this.siteHeader.menuAim( {
            rowSelector: `${$MENU_TRIGGER}`,
            activate: this.onDropMenuEnter,
            deactivate: this.onDropMenuLeave,
            submenuDirection: 'below',
            exitMenu: () => true
        } );

        const loginForm = $( '#loginForm1' );

        if ( loginForm[0] ) {
            jqueryValidate().then( () => loginForm.validate() );
        }

        // detect click events outside a menu to thaw/deactivate all menus
        $( document ).on( 'click touchstart', e => {
            if ( !this.getClosestMenu( e.target ).length ) {
                this.thawAllMenus();
            }
        } );

        // allow user to open submenus (without navigating) if using touch
        $( '.nav-drop-menu' ).on( 'touchstart', e => window.USER_IS_TOUCHING && e.stopPropagation() );

        // menu-aim
        this.dropMenus.find( $NAV_MENU ).menuAim( {
            rowSelector: '> ul > li',
            activate: this.activateMenuItem,
            deactivate: this.deactivateMenuItem,
            // note -> "exitMenu => true" required to resolve last active not reactivated edge-case
            // https://github.com/kamens/jQuery-menu-aim/issues/14#issuecomment-17252987
            exitMenu: () => true
        } );

    }

    onInPageNavigation = e => {
        const activeMenu = $( e.currentTarget ).parents( ['data-state="active"'] );
        this.deactivateMenu( activeMenu );
    };

    onDropMenuEnter = el => {
        // this._menuHoverTimeoutId = setTimeout( () => this.activateMenu( el ), 90 );
        this.activateMenu( el )
    };

    onDropMenuLeave = el => {
        if ( this._frozenMenus.length ) {
            return;
        }

        // clearTimeout( this._menuHoverTimeoutId );
        this.deactivateMenu( el );
    };

    onFocusin = e => {
        const menu = this.getClosestMenu( e.target );
        this.freezeMenu( menu );
    };

    toggleMenu = e => {
        const el = $( e.currentTarget );

        (el[0].dataset['state'] === 'active')
            ? this.deactivateMenu( el )
            : this.activateMenu( el );
    };

    getClosestMenu = target => $( target ).closest( $MENU_TRIGGER );

    freezeMenu = ( menu ) => {
        this._frozenMenus = this._frozenMenus.concat( [menu] );
    };

    thawAllMenus = () => {
        this._frozenMenus.forEach( menu => {
            menu.find( 'input' ).blur();
            this.deactivateMenu( menu );
        } );

        this._frozenMenus = [];
    };

    activateMenu = ( el ) => {
        const $el = $( el )
        if ( $el[0].dataset['state'] === 'active' ) {
            return;
        }

        this.thawAllMenus();
        $el.attr('data-state','active');
        this.contentPane.attr( 'data-overlay', 'active' );
        $el.find( $DROP_MENU ).removeClass( 'hidden' );
    };

    deactivateMenu = el => {
        const $el = $( el );

        this.resetActive();
        $el.removeAttr('data-state');
        this.contentPane.attr( 'data-overlay', 'inactive' );
        $el.find( $DROP_MENU ).addClass( 'hidden' );
    };

    activateMenuItem = el => {
        const menuId = el.getAttribute( 'data-menu-id' );
        this.getMenuFigure( menuId ).removeClass( 'hidden' );

        $(el).attr('data-state','active');
    };

    deactivateMenuItem = el => {
        const menuId = el.getAttribute( 'data-menu-id' );
        this.getMenuFigure( menuId ).addClass( 'hidden' );

        $(el).removeAttr('data-state');
    };

    resetActive = () => {
        // hide ad placements & toggle active menuItem in menu
        this.submenuAds.addClass( 'hidden' );
        this.navItems.removeAttr( 'data-state' );
    };

    getMenuFigure = id => {
        return this.submenuAds.filter( ( i, el ) => el.getAttribute( 'data-ad-id' ) === id );
    };

    async initCollapsingHeader( container, context ) {
        await Waypoints();

        const wp = new Waypoint( {
            element: document.querySelector( container ),
            handler: dir => {
                const shouldCollapse = $( context )[0].scrollHeight - window.innerHeight > this.siteHeader.height();

                if ( shouldCollapse ) {
                    this.siteBody.toggleClass( 'header--collapsed', dir !== 'up' );
                }
            },
            offset: -this.siteHeader.height(),
            context: document.querySelector( context )
        } );
    }
}

export default DesktopMenu;
